import { Controller } from '@hotwired/stimulus';

import { apply } from '@/modules/mask';

export default class extends Controller {
  connect() {
    apply(this.element, {
      definitions: {
        H: /[0-2]/,
        h: /[0-9]/,
        M: /[0-5]/,
        m: /[0-9]/,
      },
      lazy: true,
      mask: 'Hh:Mm',
    });
  }
}
